import { getCurrentUserID } from 'src/modules/authentication/storage/user/utils';
import DiagramAPIs from '../../db/diagram';
import { mapPaginatedDiagrams } from './utils';
export const epDiagramQueries = {
    async ep_diagramSearch(_, { ancestorID, pagination, query, topic, }, context) {
        const result = await DiagramAPIs.search(getCurrentUserID(), { query, ancestorID, topic }, pagination);
        return mapPaginatedDiagrams(result);
    },
};
